<template>
    <div id="box_component" class="box-component">
        <div class="box-component-inner">
            <h2>Forgot password</h2>
            <form @submit.prevent="validate">
                <div class="mw--360">
                    <p>Please enter new password:</p>
                    <div class="form-item form-item-text" :class="{ 'field-error': errors.has('new_password') && showErrors }">
                        <label for="settings_new_password"
                               class="form-label">
                            New password
                        </label>
                        <input  id="settings_new_password"
                                class="settings-new-password"
                                name="new_password"
                                v-model="newPassword"
                                ref="new_password"
                                v-validate
                                data-vv-rules="required"
                                data-vv-as="new password"
                                :disabled="progress"
                                type="password">
                        <p class="field-error--description" v-show="errors.has('new_password') && showErrors">{{ errors.first('new_password') }}</p>
                    </div>
                    <div class="form-item form-item-text" :class="{ 'field-error': errors.has('repeat_password') && showErrors }">
                        <label for="settings_repeat_password"
                               class="form-label">
                            Repeat password
                        </label>
                        <input  id="settings_repeat_password"
                                class="settings-repeat-password"
                                name="repeat_password"
                                v-model="repeatPassword"
                                v-validate
                                data-vv-rules="required|confirmed:new_password"
                                data-vv-as="password"
                                :disabled="progress"
                                type="password">
                        <p class="field-error--description" v-show="errors.has('repeat_password') && showErrors">{{ errors.first('repeat_password') }}</p>
                    </div>
                </div>
                <div class="form-actions">
                    <button class="button--primary password"
                            :class="{ 'button--progress': progress }"
                            :type="progress ? 'button' : 'submit'">Change password</button>
                    <a @click="goToLogin()" class="prev-link">Back to login</a>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['view'],
        dependencies: ['api', 'popup', 'status', 'user'],
        data () {
            return {
                progress: false,
                newPassword: '',
                repeatPassword: '',
                showErrors: false
            }
        },
        methods: {
            changeView (view) {
                this.$store.commit('loginFormView', 2);
                setTimeout(() => {
                    this.$store.commit('loginFormView', view);
                }, 600);
            },
            goToLogin () {
                this.$store.commit('loginFormView', 2);
                setTimeout(() => {
                    this.$router.push({ name: 'Login' });
                }, 600);
            },
            success() {
                this.progress = false;
                this.popup.show('Your password was changed correctly. You can now log in');
            },
            validate () {
                this.showErrors = false;
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submit();
                    } else {
                        this.showErrors = true;
                    }
                });
            },
            submit () {
                let vm = this;
                vm.progress = true;

                vm.$http.post(this.api.user.password.new, {
                    newPassword: vm.newPassword,
                    newPasswordConfirmed: vm.repeatPassword,
                    token: vm.$router.history.current.params.token
                }).then(response => {
                    this.$router.push({ name: 'Login' });
                    this.success(response.data);
                }, error => {
                    setTimeout(function () {
                        vm.progress = false;
                        if (vm.status['status' + error.status]) {
                            vm.status['status' + error.status]();
                        } else {
                            vm.popup.show(error.data.errors[0].message);
                        }
                    }, 600);
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_colors.scss';
    @import '../../../assets/scss/_guest.scss';

    .remind-password-form-component{

    }

    .form-label{
        text-align: left;
    }

    .button--text.remind-password{
        display: block;
        font-size: 12px !important;
        margin: 15px auto -30px;
        cursor: pointer;
        color: $base1 !important;

        &:hover,
        &:focus{
            text-decoration: underline;
            color: $base1 !important;
        }
    }

    .prev-link{
        cursor: pointer;
        display: block;
        margin: 11px 0 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/remind-password/partials/RemindPasswordForm.vue